import React, { useState, useEffect } from "react";
import styles from "./StatProspect.module.sass";
import cn from "classnames";
import Card from "../../../components/Card";
import Icon from "../../../components/Icon";
import { PieChart, Pie, Tooltip, Cell, ResponsiveContainer } from "recharts";
import { getDemoAccountStats } from "../../../services/dashboard.service"; 

const defaultData = [
  { name: "Comptes démo", value: 0 },
  { name: "Comptes actifs", value: 0 },
];
const COLORS = ["#B5E4CA", "#FFCC5C"];

const StatProspect = ({ className }) => {
  const [loading, setLoading] = useState(true);
  const [demoData, setDemoData] = useState(defaultData);
  const [percentages, setPercentages] = useState([
    { title: "Comptes démo", percent: 0, fill: "#B5E4CA" }, 
    { title: "Comptes actifs", percent: 0, fill: "#FFCC5C" },
  ]);
  
  useEffect(() => {
    const fetchDemoStats = async () => { 
      try {
        setLoading(true);
        const stats = await getDemoAccountStats(); 
        
        if (stats && stats.total > 0) {
          const data = [
            { name: "Comptes démo", value: stats.demoAccounts },
            { name: "Comptes actifs", value: stats.nonDemoAccounts }
          ];
          setDemoData(data);
          
          const total = stats.total;
          const updatedPercentages = [
            { title: "Comptes démo", percent: Math.round((stats.demoAccounts / total) * 100), fill: "#B5E4CA" },
            { title: "Comptes actifs", percent: Math.round((stats.nonDemoAccounts / total) * 100), fill: "#FFCC5C" }
          ];
          setPercentages(updatedPercentages);
        } else {
          setDemoData(defaultData);
          setPercentages([
            { title: "Comptes démo", percent: 0, fill: "#B5E4CA" },
            { title: "Comptes actifs", percent: 0, fill: "#FFCC5C" }
          ]);
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des statistiques de comptes démo:', error);
        setDemoData(defaultData); 
        setPercentages([
          { title: "Comptes démo", percent: 0, fill: "#B5E4CA" },
          { title: "Comptes actifs", percent: 0, fill: "#FFCC5C" }
        ]); 
      } finally {
        setLoading(false);
      }
    };
    
    fetchDemoStats(); 
  }, []); 

  return (
    <Card
      className={cn(styles.card, className)}
      title="Répartition des comptes"
      classTitle="title-yellow"
    >
      <div className={styles.chart}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart width={400} height={400}>
            <Tooltip
              contentStyle={{
                backgroundColor: "#272B30",
                borderColor: "rgba(255, 255, 255, 0.12)",
                borderRadius: 8,
                boxShadow:
                  "0px 4px 8px rgba(0, 0, 0, 0.1), 0px 2px 4px rgba(0, 0, 0, 0.1), inset 0px 0px 1px #000000",
              }}
              labelStyle={{ fontSize: 12, fontWeight: "500", color: "#fff" }}
              itemStyle={{
                padding: 0,
                textTransform: "capitalize",
                fontSize: 12,
                fontWeight: "600",
                color: "#fff",
              }}
              formatter={(value) => [`${value} comptes`, '']}
            />
            <Pie
              data={loading ? defaultData : demoData}
              cx={140} 
              cy={110} 
              innerRadius={88}
              outerRadius={110}
              fill="#8884d8"
              paddingAngle={1}
              dataKey="value"
            >
              {(loading ? defaultData : demoData).map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </div>
      <div className={styles.legend}>
        {percentages.map((x, index) => (
          <div className={styles.indicator} key={index}>
            <div className={styles.title} style={{ color: x.fill }}>{x.title}</div>
            <div className={styles.percent}>{x.percent}%</div>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default StatProspect;
